/**
 * Brand configuration and constants
 */
import animatedFire from '../animated-fire-white.webp';

export const BRAND_CONFIG = {
  name: 'Full Fire TCG',
  emoji: '🔥',
  animatedEmoji: (
    <img
      src={animatedFire}
      alt="Animated Full Fire TCG logo"
      aria-hidden="true"
      className="-mt-1.5 h-7 w-7 md:h-10 md:w-10"
    />
  ),
  colours: {
    light: '#fcff84',
    medium: '#ffc103',
    dark: '#ffc103',
  },
};

export const NAV_LINKS = [
  { href: '#about', label: 'About' },
  { href: '#stock', label: "What's new" },
  { href: '#location', label: 'Where we are' },
  { href: '#contact', label: 'Contact' },
];

export const CAROUSEL_CONFIG = {
  FADE_MS: 300,
  AUTO_ROTATE_INTERVAL: 15000,
};
